var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-input',_vm._g(_vm._b({attrs:{"error":_vm.error,"type":"number"}},'core-input',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }